
import axios from "axios";
import { apiGet } from "../../../API/Service/apiClient";
import { getPHP_Url } from "../../../MIS/Global";

export const handleWA_text_sms = async ({ 
  setSmsLoading,mob,otp
}) => {  
  const url = `${getPHP_Url()}wa/send-text`;  

  let name="friend";
  const params = {
    mob: mob,
    text: "*account registration*",
    otp: `*${otp}*`    
  };  

  setSmsLoading(true);
  try {
    const response = await axios.get(url, { params });
    // alert(1)
    // alert("API Response: " + JSON.stringify(response));
  } catch (err) {
    // alert("Errors: " + err.message + "\nDetails: " + JSON.stringify(err));
    // console.log(err)
  } finally {
    // setSmsLoading(false);
  }
}; 

export const handleWA_verify_sms = async ({ 
  mob,otp
}) => {  
  const url = `${getPHP_Url()}wa/verify`;    
  const params = {   
    mob:mob,
    otp: otp
  };    
  try {
    const response = await axios.get(url, { params });    
    if(response?.data?.match===true){
      return true;
    }else{            
      return false;
    }
  } catch (err) {
    // alert("Errors: " + err.message + "\nDetails: " + JSON.stringify(err));
    // console.log(err)
  } finally {
    // setIsVerify(false);
  }
};

export const handleExist_user = async ({
  mob,  
  setVerifyLoading,
  setVerify,next
}) => {
  setVerifyLoading(true);  
  try {
    let data={page:1,limit:1,mob:mob}
    const resData = await apiGet("user-login", data);
    if(resData?.data?.length > 0){
      alert('This mobile number is already registered. Please use a different number.')
      setVerify(false)
      // setFieldValue('mob','')
    }else{
      setVerify(true);
      next();      
    }    
    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setVerifyLoading(false);
  }
};